import styled from 'styled-components';


const Header = styled.header`
    background-image: linear-gradient(to bottom, #192320, #9E997B);
    background-position: 50% 50%;
    background-size: cover;
    height: 100vh;
`;


export default Header;